import { PaymentElement } from "@stripe/react-stripe-js";
import React from "react";
import styled from "styled-components";

import type { PaymentFormProps } from "./PaymentForm";

const PaymentFormContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding-top: 6px;
`;

const ErrorMessage = styled.div`
    color: #FF4500;
    font-family: "Source Sans Pro";
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 125%; /* 12.5px */
`;

export function PaymentForm({ paymentMethodCreationError, handlePaymentElementChange }: PaymentFormProps) {
    return (
        <PaymentFormContainer>
            <PaymentElement
                onChange={handlePaymentElementChange}
                options={{
                    layout: {
                        type: "tabs",
                        defaultCollapsed: false,
                        radios: false,
                        spacedAccordionItems: false
                    },
                    wallets: {
                        applePay: "auto",
                        googlePay: "never",
                        link: "auto"
                    },
                    paymentMethodOrder: ["card", "applePay", "link"],
                    terms: {
                        card: "never"
                    },
                    fields: {
                        billingDetails: {
                            address: {
                                country: "never",
                                postalCode: "never"
                            }
                        }
                    }
                }}
            />
            {paymentMethodCreationError &&
                <ErrorMessage>{paymentMethodCreationError}</ErrorMessage>
            }
        </PaymentFormContainer>
    );
}
